import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Moment from 'react-moment';

const GeoLocModal = ({ geoData, setGeoData }) => {

    const handleClose = () => {
        setGeoData({ ...geoData, show: false });
    }

    return (
        geoData.show && (
            <Dialog open={geoData.show} onClose={handleClose}>
                <DialogTitle>Geo Loc Data</DialogTitle>
                <DialogContent>
                    {geoData.user.geoData[0] ? (
                        <>
                            <Typography>Lat: <span>{geoData.user.geoData[0].latitude}</span></Typography>
                            <Typography>Lon: <span>{geoData.user.geoData[0].longitude}</span></Typography>
                            <Typography>Zip: <span>{geoData.user.geoData[0].zipCode}</span></Typography>
                            <Typography>IP: <span>{geoData.user.ip}</span></Typography>
                            <Typography>Last Update: <Moment>{geoData.user.geoData[0].dateTime}</Moment></Typography>
                        </>
                    ) : (
                        <Typography>No Data Available</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    )
};

export default GeoLocModal;
